<template>
  <div class="home">
    <Profile msg="Your Profile" />
  </div>
</template>

<script>
// @ is an alias to /src
import Profile from '@/components/Profile.vue';

export default {
  name: 'home',
  components: {
    Profile,
  },
};
</script>
